import frame0 from "./0.png";
import frame1 from "./1.png";
import frame10 from "./10.png";
import frame100 from "./100.png";
import frame101 from "./101.png";
import frame102 from "./102.png";
import frame103 from "./103.png";
import frame104 from "./104.png";
import frame105 from "./105.png";
import frame106 from "./106.png";
import frame107 from "./107.png";
import frame108 from "./108.png";
import frame109 from "./109.png";
import frame11 from "./11.png";
import frame110 from "./110.png";
import frame111 from "./111.png";
import frame112 from "./112.png";
import frame113 from "./113.png";
import frame114 from "./114.png";
import frame115 from "./115.png";
import frame116 from "./116.png";
import frame117 from "./117.png";
import frame118 from "./118.png";
import frame119 from "./119.png";
import frame12 from "./12.png";
import frame120 from "./120.png";
import frame121 from "./121.png";
import frame122 from "./122.png";
import frame123 from "./123.png";
import frame124 from "./124.png";
import frame125 from "./125.png";
import frame126 from "./126.png";
import frame127 from "./127.png";
import frame128 from "./128.png";
import frame129 from "./129.png";
import frame13 from "./13.png";
import frame130 from "./130.png";
import frame131 from "./131.png";
import frame132 from "./132.png";
import frame133 from "./133.png";
import frame134 from "./134.png";
import frame135 from "./135.png";
import frame136 from "./136.png";
import frame137 from "./137.png";
import frame138 from "./138.png";
import frame139 from "./139.png";
import frame14 from "./14.png";
import frame140 from "./140.png";
import frame141 from "./141.png";
import frame142 from "./142.png";
import frame143 from "./143.png";
import frame144 from "./144.png";
import frame145 from "./145.png";
import frame146 from "./146.png";
import frame147 from "./147.png";
import frame148 from "./148.png";
import frame149 from "./149.png";
import frame15 from "./15.png";
import frame150 from "./150.png";
import frame151 from "./151.png";
import frame152 from "./152.png";
import frame153 from "./153.png";
import frame154 from "./154.png";
import frame155 from "./155.png";
import frame156 from "./156.png";
import frame157 from "./157.png";
import frame158 from "./158.png";
import frame159 from "./159.png";
import frame16 from "./16.png";
import frame160 from "./160.png";
import frame161 from "./161.png";
import frame162 from "./162.png";
import frame163 from "./163.png";
import frame164 from "./164.png";
import frame165 from "./165.png";
import frame166 from "./166.png";
import frame167 from "./167.png";
import frame168 from "./168.png";
import frame169 from "./169.png";
import frame17 from "./17.png";
import frame170 from "./170.png";
import frame171 from "./171.png";
import frame172 from "./172.png";
import frame173 from "./173.png";
import frame174 from "./174.png";
import frame175 from "./175.png";
import frame18 from "./18.png";
import frame19 from "./19.png";
import frame2 from "./2.png";
import frame20 from "./20.png";
import frame21 from "./21.png";
import frame22 from "./22.png";
import frame23 from "./23.png";
import frame24 from "./24.png";
import frame25 from "./25.png";
import frame26 from "./26.png";
import frame27 from "./27.png";
import frame28 from "./28.png";
import frame29 from "./29.png";
import frame3 from "./3.png";
import frame30 from "./30.png";
import frame31 from "./31.png";
import frame32 from "./32.png";
import frame33 from "./33.png";
import frame34 from "./34.png";
import frame35 from "./35.png";
import frame36 from "./36.png";
import frame37 from "./37.png";
import frame38 from "./38.png";
import frame39 from "./39.png";
import frame4 from "./4.png";
import frame40 from "./40.png";
import frame41 from "./41.png";
import frame42 from "./42.png";
import frame43 from "./43.png";
import frame44 from "./44.png";
import frame45 from "./45.png";
import frame46 from "./46.png";
import frame47 from "./47.png";
import frame48 from "./48.png";
import frame49 from "./49.png";
import frame5 from "./5.png";
import frame50 from "./50.png";
import frame51 from "./51.png";
import frame52 from "./52.png";
import frame53 from "./53.png";
import frame54 from "./54.png";
import frame55 from "./55.png";
import frame56 from "./56.png";
import frame57 from "./57.png";
import frame58 from "./58.png";
import frame59 from "./59.png";
import frame6 from "./6.png";
import frame60 from "./60.png";
import frame61 from "./61.png";
import frame62 from "./62.png";
import frame63 from "./63.png";
import frame64 from "./64.png";
import frame65 from "./65.png";
import frame66 from "./66.png";
import frame67 from "./67.png";
import frame68 from "./68.png";
import frame69 from "./69.png";
import frame7 from "./7.png";
import frame70 from "./70.png";
import frame71 from "./71.png";
import frame72 from "./72.png";
import frame73 from "./73.png";
import frame74 from "./74.png";
import frame75 from "./75.png";
import frame76 from "./76.png";
import frame77 from "./77.png";
import frame78 from "./78.png";
import frame79 from "./79.png";
import frame8 from "./8.png";
import frame80 from "./80.png";
import frame81 from "./81.png";
import frame82 from "./82.png";
import frame83 from "./83.png";
import frame84 from "./84.png";
import frame85 from "./85.png";
import frame86 from "./86.png";
import frame87 from "./87.png";
import frame88 from "./88.png";
import frame89 from "./89.png";
import frame9 from "./9.png";
import frame90 from "./90.png";
import frame91 from "./91.png";
import frame92 from "./92.png";
import frame93 from "./93.png";
import frame94 from "./94.png";
import frame95 from "./95.png";
import frame96 from "./96.png";
import frame97 from "./97.png";
import frame98 from "./98.png";
import frame99 from "./99.png";
export const sleeping: string[] = [
  frame0,
  frame1,
  frame2,
  frame3,
  frame4,
  frame5,
  frame6,
  frame7,
  frame8,
  frame9,
  frame10,
  frame11,
  frame12,
  frame13,
  frame14,
  frame15,
  frame16,
  frame17,
  frame18,
  frame19,
  frame20,
  frame21,
  frame22,
  frame23,
  frame24,
  frame25,
  frame26,
  frame27,
  frame28,
  frame29,
  frame30,
  frame31,
  frame32,
  frame33,
  frame34,
  frame35,
  frame36,
  frame37,
  frame38,
  frame39,
  frame40,
  frame41,
  frame42,
  frame43,
  frame44,
  frame45,
  frame46,
  frame47,
  frame48,
  frame49,
  frame50,
  frame51,
  frame52,
  frame53,
  frame54,
  frame55,
  frame56,
  frame57,
  frame58,
  frame59,
  frame60,
  frame61,
  frame62,
  frame63,
  frame64,
  frame65,
  frame66,
  frame67,
  frame68,
  frame69,
  frame70,
  frame71,
  frame72,
  frame73,
  frame74,
  frame75,
  frame76,
  frame77,
  frame78,
  frame79,
  frame80,
  frame81,
  frame82,
  frame83,
  frame84,
  frame85,
  frame86,
  frame87,
  frame88,
  frame89,
  frame90,
  frame91,
  frame92,
  frame93,
  frame94,
  frame95,
  frame96,
  frame97,
  frame98,
  frame99,
  frame100,
  frame101,
  frame102,
  frame103,
  frame104,
  frame105,
  frame106,
  frame107,
  frame108,
  frame109,
  frame110,
  frame111,
  frame112,
  frame113,
  frame114,
  frame115,
  frame116,
  frame117,
  frame118,
  frame119,
  frame120,
  frame121,
  frame122,
  frame123,
  frame124,
  frame125,
  frame126,
  frame127,
  frame128,
  frame129,
  frame130,
  frame131,
  frame132,
  frame133,
  frame134,
  frame135,
  frame136,
  frame137,
  frame138,
  frame139,
  frame140,
  frame141,
  frame142,
  frame143,
  frame144,
  frame145,
  frame146,
  frame147,
  frame148,
  frame149,
  frame150,
  frame151,
  frame152,
  frame153,
  frame154,
  frame155,
  frame156,
  frame157,
  frame158,
  frame159,
  frame160,
  frame161,
  frame162,
  frame163,
  frame164,
  frame165,
  frame166,
  frame167,
  frame168,
  frame169,
  frame170,
  frame171,
  frame172,
  frame173,
  frame174,
  frame175,
];
